type SettingsTab = 'personal_info' | 'general_settings' | 'my_subscriptions' | 'change_password'

interface SettingsDialogOptions {
  initialTab?: SettingsTab
}

const model = ref(false)
const selectedTab = ref<SettingsTab>('personal_info')

export const useSettingsDialog = () => {
  const show = (options: SettingsDialogOptions = {}) => {
    model.value = true
    selectedTab.value = options.initialTab || 'personal_info'
  }

  const hide = () => {
    model.value = false
  }

  const setTab = (tab: SettingsTab) => {
    selectedTab.value = tab
  }

  return {
    model,
    selectedTab,
    show,
    hide,
    setTab,
  }
}
